"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxDeductibleFloodCalculationType = exports.FloodZoneDeterminationMicroflowStatus = exports.FloodInsuranceStatus = void 0;
var FloodInsuranceStatus;
(function (FloodInsuranceStatus) {
    FloodInsuranceStatus["notApplicable"] = "notApplicable";
    FloodInsuranceStatus["waitingDocuments"] = "waitingDocuments";
    FloodInsuranceStatus["reviewFailWaitingDocumentResubmission"] = "reviewFailWaitingDocumentResubmission";
    FloodInsuranceStatus["expiredDocumentsWaitingResubmission"] = "expiredDocumentsWaitingResubmission";
    FloodInsuranceStatus["documentPendingReview"] = "documentPendingReview";
    FloodInsuranceStatus["documentReviewSuccess"] = "documentReviewSuccess";
    FloodInsuranceStatus["lifeOfLoanWaitingDocuments"] = "lifeOfLoanWaitingDocuments";
})(FloodInsuranceStatus || (exports.FloodInsuranceStatus = FloodInsuranceStatus = {}));
/**
 * Microflow status for origination flood-zone determination (AutoHit → LoL Original waterfall).
 * Used alongside LoanApplicationStatus.floodZoneDeterminationPending to explain *why* we are still
 * waiting and to support idempotent re-runs of the determination job.
 */
var FloodZoneDeterminationMicroflowStatus;
(function (FloodZoneDeterminationMicroflowStatus) {
    // CoreLogic Life of Loan research is still outstanding (e.g. S0011). We cannot yet decide
    // whether flood insurance is required.
    FloodZoneDeterminationMicroflowStatus["researchPending"] = "researchPending";
    // Determination completed and the applicant does not need flood insurance.
    FloodZoneDeterminationMicroflowStatus["completeNoInsuranceRequired"] = "completeNoInsuranceRequired";
    // Determination completed and flood insurance is required. The LA will advance to
    // floodInsuranceVerification.
    FloodZoneDeterminationMicroflowStatus["completeInsuranceRequired"] = "completeInsuranceRequired";
    // AutoHit and LoL Original both failed in ways that are not retryable without manual review.
    FloodZoneDeterminationMicroflowStatus["failed"] = "failed";
})(FloodZoneDeterminationMicroflowStatus || (exports.FloodZoneDeterminationMicroflowStatus = FloodZoneDeterminationMicroflowStatus = {}));
/**  @TranslateToPython @TranslateToEnum  */
var MaxDeductibleFloodCalculationType;
(function (MaxDeductibleFloodCalculationType) {
    MaxDeductibleFloodCalculationType["default"] = "default";
    MaxDeductibleFloodCalculationType["minOfDefaultAndPercentOfRequiredCoverage"] = "minOfDefaultAndPercentOfRequiredCoverage";
})(MaxDeductibleFloodCalculationType || (exports.MaxDeductibleFloodCalculationType = MaxDeductibleFloodCalculationType = {}));
